// src/components/survey/SurveyHeader.jsx
import React, { useState } from "react";
import { Button, Progress } from "antd";
import { GalleryHorizontal, GalleryVertical } from "lucide-react";
import { OrganizationsIcon } from "../../assets/svgs/icons";
import { getFormOrganizationLogoUrl, pickMediaUrl } from "../../utils/formTabs";

const SurveyHeader = ({ organization, form, onCancel, onDirectionChange }) => {
  const storedDirection =
    localStorage.getItem("surveyAnimationDirection") || "horizontal";

  const [viewType, setViewType] = useState(storedDirection);
  const [logoError, setLogoError] = useState(false);

  const logoUrl =
    getFormOrganizationLogoUrl(form) ||
    pickMediaUrl(organization?.logo) ||
    pickMediaUrl(organization?.image);

  return (
    <div
      className="flex flex-wrap items-start justify-between rounded-t-2xl border-b p-3 sm:flex-row sm:items-center sm:p-4"
      style={{ background: organization?.color }}
    >
      <div className="flex items-center gap-2 mb-2 sm:mb-0">
        {logoUrl && !logoError ? (
          <img
            src={logoUrl}
            alt={organization?.name}
            className="w-8 sm:w-10 h-8 sm:h-10 rounded-full border border-gray-200 object-cover"
            onError={() => setLogoError(true)}
          />
        ) : (
          <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full bg-white/20 flex items-center justify-center">
            <OrganizationsIcon />
          </div>
        )}
        <div>
          <span className="text-black text-xs sm:text-sm font-medium">
            {organization?.name || "Survey"}
          </span>
          {/* <p className="mt-0 text-xs mb-0 text-gray-800 break-words max-w-[200px] sm:max-w-none">
            {organization?.location?.name || organization?.address}
          </p> */}
        </div>
      </div>
      <div className="flex items-center justify-between gap-3">
        <div className="inline-flex gap-1 bg-secondary rounded-xl p-2">
          <button
            className={`cursor-pointer p-1 border-0 rounded-lg flex items-center justify-center leading-none ${
              viewType === "horizontal" ? "bg-primary text-white" : ""
            }`}
            onClick={() => {
              onDirectionChange("horizontal");
              setViewType("horizontal");
            }}
          >
            <GalleryHorizontal size={16} className="cursor-pointer" />
          </button>
          <button
            className={`cursor-pointer p-1 border-0 rounded-lg flex items-center justify-center leading-none ${
              viewType === "vertical" ? "bg-primary text-white" : ""
            }`}
            onClick={() => {
              onDirectionChange("vertical");
              setViewType("vertical");
            }}
          >
            <GalleryVertical size={16} className="cursor-pointer" />
          </button>
        </div>
        <Button
          style={{ color: "red" }}
          className="btnSecondary h-10 border-0 text-red-500"
          onClick={onCancel}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

const SurveyProgressHeader = ({
  organization,
  formData,
  currentQuestion,
  totalQuestions,
  onCancel,
}) => (
  <div className="p-2 flex flex-col sm:flex-row items-start justify-between border rounded-2xl mb-4">
    <div className="flex-1 w-full">
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 justify-between mb-2 sm:mb-0">
        <h1 className="text-base sm:text-lg font-bold text-primary">
          {formData?.title}
        </h1>
        {formData?.anonymous && (
          <div className="flex items-center border gap-2 bg-gray-50 px-2 sm:px-3 py-1 rounded-full">
            <span className="text-sm sm:text-md text-center flex items-center gap-1">
              <span className="relative">Anonymous Response</span>
            </span>
          </div>
        )}
      </div>
      <p className="text-xs sm:text-sm text-gray-500 mt-1">
        {formData?.description}
      </p>
      <div className="w-full mb-6">
        <Progress
          percent={(currentQuestion / totalQuestions) * 100}
          showInfo={false}
          strokeColor="#202835"
          className="mb-4 m-0"
        />
      </div>
    </div>
  </div>
);

export { SurveyHeader, SurveyProgressHeader };
